import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import {
  getFiberPropertyDetai,
  getMaterialPropertyDetai,
  getSamPropertyDetai,
  resetDataSetToInital,
  resetDeleteProperty,
} from "../axios/index";

import cloneDeep from "lodash/cloneDeep";
import Details from "../components/details";
import loader from "../loader.gif";

const ViewDetails = () => {
  const { moduleName, id } = useParams();
  const dispatch = useDispatch();

  const defaultMaterialDataSet = useSelector(
    (state) => state.MaterailsDetail
  );

  const [customModuleName, setCustomModuleName] = React.useState("");
  const [breadCrumbData, setBreadCrumbData] = React.useState([]);
  const [moduleFieldDataSet, setModuleFieldDataSet] = React.useState({});
  const [fields, setFields] = React.useState({});
  const [urlId, setUrlId] = React.useState(id);

  useEffect(() => {
    dispatch(resetDataSetToInital());
    dispatch(resetDeleteProperty());

    // Always keep the current route ID.
    setUrlId(id);

    if (moduleName === "material-details") {
      setCustomModuleName("material");
      setBreadCrumbData([
        { title: "Home", path: "/" },
        { title: "Materials", path: "/materials", active: false },
        { title: "Details", path: "/materials-details", active: true },
      ]);

      dispatch(getMaterialPropertyDetai({ id }));
    } else if (moduleName === "sam-details") {
      setCustomModuleName("sam");
      setBreadCrumbData([
        { title: "Home", path: "/" },
        { title: "SAM", path: "/sam", active: false },
        { title: "Details", path: "/sam-details", active: true },
      ]);

      dispatch(getSamPropertyDetai({ id }));
    } else if (moduleName === "fiber-details") {
      setCustomModuleName("fiber");
      setBreadCrumbData([
        { title: "Home", path: "/" },
        { title: "Fibers", path: "/fibers", active: false },
        { title: "Details", path: "/fiber-details", active: true },
      ]);

      dispatch(getFiberPropertyDetai({ id }));
    } else if (moduleName === "new-material") {
      setCustomModuleName("material");
      setBreadCrumbData([
        { title: "Home", path: "/" },
        { title: "Materials", path: "/materials", active: false },
        {
          title: "New Materials",
          path: "/new-materials-details",
          active: true,
        },
      ]);

      dispatch(getMaterialPropertyDetai({ id }));
    } else if (moduleName === "new-sam") {
      setCustomModuleName("sam");
      setBreadCrumbData([
        { title: "Home", path: "/" },
        { title: "SAM", path: "/sam", active: false },
        { title: "New Sam", path: "/new-sam-details", active: true },
      ]);

      // Required to initialize the SAM form.
      dispatch(getSamPropertyDetai({ id }));
    } else if (moduleName === "new-fiber") {
      setCustomModuleName("fiber");
      setBreadCrumbData([
        { title: "Home", path: "/" },
        { title: "Fibers", path: "/fibers", active: false },
        { title: "New Fiber", path: "/new-fiber-details", active: true },
      ]);

      dispatch(getFiberPropertyDetai({ id }));
    }
  }, [moduleName, id, dispatch]);

  useEffect(() => {
    const newMaterialDataSet = cloneDeep(
      defaultMaterialDataSet?.data || {}
    );

    const calculatedFieldSet =
      getCalulcatedFieldSet(newMaterialDataSet);

    setFields(calculatedFieldSet);
    setModuleFieldDataSet(newMaterialDataSet);
  }, [defaultMaterialDataSet]);

  const getCalulcatedFieldSet = (dataSet) => {
    const calculatedFieldSet = {
      fields: {},
      calc: {},
    };

    const loopModule = ["material", "sam", "fiber"];

    loopModule.forEach((module) => {
      const propertyData = dataSet?.[module]?.propertyData;

      if (!Array.isArray(propertyData) || propertyData.length === 0) {
        return;
      }

      propertyData.forEach((item, index) => {
        Object.keys(item).forEach((key, propIndex) => {
          if (calculatedFieldSet.fields[key] !== undefined) {
            calculatedFieldSet.fields[key].index = index;
            calculatedFieldSet.fields[key].propIndex = propIndex;
            calculatedFieldSet.fields[key].module = module;
          } else {
            calculatedFieldSet.fields[key] = {
              index,
              propIndex,
              module,
              targetCalculatorField: [],
            };
          }

          const propertyMetaData = item[key]?.propertyMetaData;

          if (
            propertyMetaData?.calculatedField === true &&
            propertyMetaData?.formulaUsed !== null
          ) {
            const targetCalculationColumn = JSON.parse(
              propertyMetaData.targetCalculationColumn || "[]"
            );

            calculatedFieldSet.calc[key] = {
              index,
              propIndex,
              module,
              formulaUsed: propertyMetaData.formulaUsed,
              targetCalculationColumn,
            };

            targetCalculationColumn.forEach((targetField) => {
              if (calculatedFieldSet.fields[targetField] !== undefined) {
                calculatedFieldSet.fields[
                  targetField
                ].targetCalculatorField.push(key);
              } else {
                calculatedFieldSet.fields[targetField] = {
                  index: null,
                  propIndex: null,
                  module: null,
                  targetCalculatorField: [key],
                };
              }
            });
          }
        });
      });
    });

    return calculatedFieldSet;
  };

  const renderDetailsComponent = () => {
    if (customModuleName !== "") {
      return (
        <Details
          key={`${moduleName}-${id}`}
          breadCrumbData={breadCrumbData}
          moduleName={customModuleName}
          defaultMaterialDataSet={moduleFieldDataSet}
          editStatusCustom={false}
          fields={fields}
          urlId={urlId}
          urlParams={{
            moduleName,
            id,
          }}
        />
      );
    }

    return (
      <div className="details-empty">
        <img
          src={loader}
          alt="Loading details"
          className="details-preloader"
        />
      </div>
    );
  };

  return (
    <div className="main-panel ps">
      {renderDetailsComponent()}
    </div>
  );
};

export default ViewDetails;
